import { useEffect } from 'react'
import ApplicationCooLayout from '../../layout/application-coo-layout'
import { TextSubheader } from '../../components/text/text-subheader'
import { SectionCard } from '../../components/card'
import { Separator } from '../../components/separator'
import CompletionReminderSegment from './segments/completion-reminder'
import DocumentsToBringSegment from './segments/documents-to-bring'
import DocumentsToReferSegment from './segments/documents-to-refer'
import { P2TextDescription } from 'react-bootstrap-common-script'
import { stageETrackingId } from '../../utils/wogaa-ids';
import { customWindow } from '../../models/interfaces/wogaa.interface';
import { useAppSelector } from '../../redux/hook'


function StageEPage() {
  const startApplicationFormData = useAppSelector((state) => state.app.ApplicationStartSlice.formData);
  useEffect(() => {
    if (customWindow.wogaaCustom) {
      customWindow.wogaaCustom.startTransactionalService(stageETrackingId);
      customWindow.wogaaCustom.completeTransactionalService(stageETrackingId);
    }
  }, []);
  return (
    <ApplicationCooLayout>
      <div className='polymer-application-coo__wrapper'>
        <TextSubheader subheaderMain="Stage E: Prepare For Completion" subheaderSub={startApplicationFormData.selected_hdb_property?.address} paddingLeftRight={42}/>
        <div className="d-flex justify-content-center" style={{ marginTop: "3.875rem", marginBottom:120 }}>
          <SectionCard
            required={false}
            className="flex-fill"
            activeStep={undefined}
            titleChildren={<P2TextDescription title={"Prepare for Completion"} />}
            contentChildren={
              <div className='polymer-stage-e'>
                <CompletionReminderSegment />
                <Separator variant='solid' style={{ margin: "48px 0 24px" }} />
                <DocumentsToBringSegment />
                <DocumentsToReferSegment />
              </div>
            }
          />
        </div>
      </div>
    </ApplicationCooLayout>
  )
}

export default StageEPage